import React, { useState } from 'react'
import axios from 'axios'
import { Button, message } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { saveAs } from 'file-saver'
import { ReactComponent as SuccessIcon } from '../../assets/success.svg'
import { ReactComponent as ErrorIcon } from '../../assets/error.svg'
import { ReactComponent as Logo } from '../../assets/logo.svg'

const RenderIcon = ({ success }) => (
  <div className={`circle circle--${success ? 'success' : 'error'}`}>
    <div style={{ height: '100%', width: '100%' }}>
      {success ? <SuccessIcon /> : <ErrorIcon />}
    </div>
  </div>
)

const DownloadButton = ({ requestId }) => {
  const [loading, setLoading] = useState(false)

  const handleDownload = async () => {
    setLoading(true)
    try {
      const r = await axios.get(
        `${process.env.REACT_APP_API}/api/signed-by-request/${encodeURIComponent(requestId)}`,
        { responseType: 'blob' }
      )
      saveAs(r.data, 'signed-document.pdf')
    } catch (err) {
      if (err.response && err.response.status === 410) {
        message.error('This download link has expired. Contact your advisor to request the signed document.')
      } else {
        message.error('Could not download the signed document. Please try again shortly.')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      loading={loading}
      onClick={handleDownload}
      size="large"
    >
      Download signed PDF
    </Button>
  )
}

const SigningComplete = ({ success, expired, requestId }) => {
  const generateMessage = () => {
    if (success) {
      return { title: 'Signing complete', content: 'Thank you. Your signature has been recorded.' }
    } else if (expired) {
      return {
        title: 'Link expired',
        content: 'The signing window for this document has closed. Please contact your advisor if you still need to sign.'
      }
    }
    return {
      title: 'Signing cancelled',
      content: 'You cancelled the signing. No changes were saved.'
    }
  }

  const { title, content } = generateMessage()

  return (
    <div className="brandShell">
      <header className="brandHeader">
        <Logo aria-label="Arctic" />
      </header>
      <main className="brandMain">
        <div className="brandCard brandStatus">
          <div className="brandStatus__icon">
            <RenderIcon success={success} />
          </div>
          <h1>{title}</h1>
          <p>{content}</p>
          {success && requestId && (
            <div style={{ marginTop: 20 }}>
              <DownloadButton requestId={requestId} />
            </div>
          )}
          <p style={{ marginTop: 20 }}>You can safely close this window.</p>
        </div>
      </main>
      <footer className="brandFooter">
        Arctic Securities AS
      </footer>
    </div>
  )
}

export default SigningComplete
